import { FilterListItem } from 'components/site/modals/FilterModal/FilterListItem';
import { useContext } from 'react';
import { CtxView } from 'session/ctxView';
import styled from 'styled-components/macro';
import { EWorldMapSetType } from '__generated__/globalTypes';

interface Props {
    className?: string;
}

export const FilterList = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);

    const categories = (ctxView.map?.worldMapSets ?? []).filter(
        (e) => e.type === EWorldMapSetType.CATEGORY
    );
    const categoryIds = categories.map((e) => e.worldMapSetId);

    const areAllVisible = categories.every((category) =>
        ctxView.visibleMapSetIds.includes(category.worldMapSetId)
    );

    const makeSetHidden = (setId: string) => {
        const newSetIds = ctxView.visibleMapSetIds.filter((id) => id !== setId);
        ctxView.setVisibleMapSetIds(newSetIds);
    };

    const makeSetVisible = (setId: string) => {
        const newSetIds = [...ctxView.visibleMapSetIds, setId];
        ctxView.setVisibleMapSetIds(newSetIds);
    };

    const showOnlyOne = (setId: string) => {
        const setIdsWithoutCategories = ctxView.visibleMapSetIds.filter(
            (id) => !categoryIds.includes(id)
        );
        ctxView.setVisibleMapSetIds([...setIdsWithoutCategories, setId]);
    };

    return (
        <S_FilterList className={props.className}>
            {categories.map((mapSet) => {
                const selected = ctxView.visibleMapSetIds.includes(mapSet.worldMapSetId);
                return (
                    <S_FilterListItem
                        key={mapSet.worldMapSetId}
                        label={mapSet.title}
                        isInactive={!selected}
                        iconName={selected ? 'eye' : 'eye-slash'}
                        onClick={() => {
                            if (selected) {
                                if (areAllVisible) {
                                    showOnlyOne(mapSet.worldMapSetId);
                                } else {
                                    makeSetHidden(mapSet.worldMapSetId);
                                }
                            } else {
                                makeSetVisible(mapSet.worldMapSetId);
                            }
                        }}
                    />
                );
            })}
        </S_FilterList>
    );
};

const S_FilterList = styled.div`
    padding: 10px 10px 0 10px;
`;

const S_FilterListItem = styled(FilterListItem)`
    margin-bottom: 10px;
`;
